module.exports = __webpack_public_path__ + "img/vikings-barbarian.b52fe203.png";